import { render, staticRenderFns } from "./MobileBuildGrid.vue?vue&type=template&id=b243c024"
import script from "./MobileBuildGrid.vue?vue&type=script&lang=js"
export * from "./MobileBuildGrid.vue?vue&type=script&lang=js"
import style0 from "./MobileBuildGrid.vue?vue&type=style&index=0&id=b243c024&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports